<nav class="navbar navbar-expand navbar-light bg-light capitan-sub-nav bg-sub-nav-3 pl-md-5">
<ul class="navbar-nav">
  <li class="nav-item">
    <a routerLink="./event-type" routerLinkActive="active" class="nav-link" href="#">Event Type-Wide Waitlists</a>
  </li>
  <li class="nav-item">
    <a routerLink="./events" routerLinkActive="active" class="nav-link" href="#">Individual Event Waitlists</a>
  </li>
</ul>
</nav>

<router-outlet></router-outlet>
